// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSpinner_container__X0ORX","icon":"LoadingSpinner_icon__3FP2S"};